<template>
    <div class="bg">
        <div class="scroll_wrap">
            <div class="top">
                <top></top>
            </div>
            <div class="agreement-wrap">
                <div class="title">
                    <img src="https://umed.oss-cn-hangzhou.aliyuncs.com/say/avatar/info-agree-1.png">
                </div>
                <div class="content">
                    <p>{{p1}}</p>
                    <p>{{p2}}</p>
                    <p>{{p3}}</p>
                    <p>{{p4}}</p>
                    <p>{{p5}}</p>
                    <p>{{p6}}</p>
                    <p>{{p7}}</p>
                    <p>{{p8}}</p>
                    <p>{{p9}}</p>
                    <p class="indent">{{p9_1}}</p>
                    <p class="indent">{{p9_2}}</p>
                    <p class="indent">{{p9_3}}</p>
                    <p class="indent">{{p9_4}}</p>
                    <p class="indent">{{p9_5}}</p>
                    <p>{{p10}}</p>
                </div>
            </div>

        </div>
        <div class="bottom" @click="toAgree">
            <span>{{info_confirm}}</span>
        </div>

    </div>
</template>

<script>
    import top from './Top'
    import {openId} from "@/assets/js/api";
    // import {isMobile} from "@/assets/util/util";

    export default {
        name: "SayInfo",
        components:{
            top
        },
        data(){
            return{
                p1:"1、本平台仅面向医疗卫生专业人士使用，而非针对一般公众。通过进入本平台，您承认并确认您是医疗卫生专业人士；" ,
                p2:"2、您登录本平台之后所提供的个人信息，包括您的姓名、省份、城市、所在医院等信息仅用于本平台所属项目的管理、执行和有关部门审计使用，不会用于任何商业用途；",
                p3:"3、您登录本平台所提交的科普观念、倡议口号的内容不得包含患者隐私信息、处方信息、其他不恰当政治言论等敏感信息；",
                p4:"4、您同意并提交的科普观念、倡议口号，仅用于项目参考使用。本项目主办方或委托方具有使用权；",
                p5:"5、本平台所有方不参与任何医疗诊治，亦不承担任何与医疗诊治相关的责任；",
                p6:"6、您自愿参与本项目，并确保所提供信息的真实性和准确性。",
                p7:"7、授权人在此授权被授权人和/或其关联公司、品牌方，根据本授权书之授权内容使用涉及授权人【肖像】的视频、平面设计宣传品等， 具体事宜如下: ",
                p8:"8、使用期限:【肖像】内容授权期限为【2022】年【10】月【1】日至【2022】年【11】月【30】日。 ",
                p9:"9、授权内容使用范围:仅限用于“北京高血压防治协会” (以下简称:品牌)主办的“为爱发声”项目。 ",
                p9_1:"(1)授权内容:允许被授权人使用含有授权人【肖像】 的视频、视频中的一帧或多帧图像以及宣传品用于非商业用途。",
                p9_2:"(2)授权内容使用形式:被授权人仅可以宣传推广品牌为目的使用授权内容，被授权人可将授权内容用于线上广告、活动页面、宣传册。 ",
                p9_3:"(3)授权内容授权使用范围:【为爱发声项目所有线上、线下传播渠道】（包括但不限于微信、快手、抖音  等）。 ",
                p9_4:"(4)被授权人可以根据不同的非商业目的，在法律允许的范围内，对肖像作品进行被授权人认为合理和适当的编辑、删改、艺术加工。被授权人可以根据不同的商业和非商业目的，" +
                      "自行或授权任何第三方将肖像作品或修改后的肖像作品，单独或辅以文字、声音、图片和其他影像等方式， 用于发布、出版、新闻、广告等法律允许的任何用 途。授权人对此不会加以任何限制，" +
                      "也不会要求任何性质的费用、报酬或补偿。",
                p9_5:"(5)被授权人不得利用授权内容进行不利于授权人的品牌及形象或会给授权人造成负面影响的报道、宣传。 " +
                      "授权人在此确认，涉及授权人【肖像】视频及宣传品仅用于“为爱发声”项目，被授权人无需支付额外费用。 " +
                      "在使用期间，被授权人需要将【肖像】内容用于本授权书约定以外的用途时，需事先取得授权人的同意。 " +
                      "授权人承诺，其签署本授权书时，在授予被授权人以及其授权的其他第三方任何权利时，不受其他授权书、" +
                      "协议或任何有效法律文件的约束，即授权人在此授权及承诺行为是完全有效的，否则授权人将承担赔偿由此给被授权人及其授权的其他第三方造成的全部损失的责任。 " +
                      "授权人对视频广告及宣传品不享有著作权，承诺不会就视频广告及宣传品有关的肖像权、隐私权、名誉权、著作权等问题，向被授权人或受被授权人委托制作、使用、" +
                      "播放视频广告及宣传品的第三方，提出任何权利要求。",
                p10:"10、在使用期限届满后，需后台删除相关内容。",
                info_confirm:"同意",
                openid:localStorage.getItem("openid"),
                code:this.$route.query.code,
            }
        },
        methods:{
            toAgree(){
                this.$router.go(-1)
            },
            async getOpenId(code){
                const res = await openId({code})
                if(res.data.success){
                    this.openId= res.data.openId;
                    localStorage.setItem("openid",this.openId)
                }else{
                    let url = "http://app.iumed.com.cn/say/agree"
                    window.location.replace("http://tang.iumed.com.cn?url="+url)
                }
            },
        },
        mounted() {

            // localStorage.setItem("openid","123");
            // this.openid = localStorage.getItem("openid")

            if(this.openid==null){
                if(this.code!=null){
                    this.getOpenId(this.code)
                }else{
                    let url = "http://app.iumed.com.cn/say/agree"
                    window.location.replace("http://tang.iumed.com.cn?url="+url)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: #FFF;
        display: flex;
        flex-flow: column nowrap;
        position: relative;
    }
    .scroll_wrap{
        overflow: scroll;
        flex-grow: 1;
    }
    .agreement-wrap{
        .title{
            img{
                width: 100%;
            }
        }
        .content{
            background: #f8f8f8;
            padding: 20px 0;
            font-size: 13px;
            p{
                margin: 0 10px 8px 10px;
                text-align: left;
                /*text-indent: 25px;*/
            }
            p:first-child{
                margin-top: 10px;
            }
        }
    }
    .bottom{
        padding: 20px;
        text-align: right;
        margin-right: 5%;
        span{
            font-size: 13px;
            color: #FFF;
            padding: 3px 15px;
            background: #1d5688;
            border-radius: 15px;
        }
    }
    .indent{
        text-indent: 25px;
    }
</style>
